<template>
	<div class="animated fadeIn">
		<h1 class="text-light">{{$t('members_setting.title')}}</h1>

		<div v-if="isDemo == 'NO'" class="col-xs-12 col-md-12 text-center mt-3">
			<b-button variant="primary" class="top-up-btn" @click="popUserInfoModal()">{{$t('members_setting.user_info')}}</b-button>
		</div>

		<div v-if="isDemo == 'NO'" class="col-xs-12 col-md-12 text-center mt-3">
			<b-button variant="primary" class="top-up-btn" @click="popUserPasswordModifyModal()">{{$t('members_setting.change_password')}}</b-button>
		</div>

		<div v-if="isDemo == 'NO'" class="col-xs-12 col-md-12 text-center mt-3">
			<b-button variant="primary" class="top-up-btn" @click="popCarMemberRegisterModal()">{{$t('members_setting.car_members')}}</b-button>
		</div>

		<div v-if="isDemo == 'NO'" class="col-xs-12 col-md-12 text-center mt-3">
			<b-button variant="primary" class="top-up-btn" @click="popMemberRegisterModal()">{{$t('members_setting.members')}}</b-button>
		</div>

		<b-modal :title="$t('qrcode_scanning')" v-model="showCameraModal" :ok-title="$t('ok')" :ok-only="true" :hide-footer="true" @hidden="hideScanner()">
		<b-alert :show="showCameraModal" variant="success"><i class="fa fa-exclamation-triangle"></i> {{$t('please_qrcode_scanning')}}</b-alert>
		<!-- <canvas id="qrcode-window" v-if="show_qrcode_canvas"></canvas> -->
		<!-- <video id="qrcode-video" playsinline muted></video> -->
		<video
			v-show="showCameraModal"
			id="qrvideo"
			autoplay
			muted
			loop
			playsinline
			webkit-playsinline
			style="border: 1px solid gray; width: 100%; height: 100%"></video>
		<p class="text-primary">{{qrcode_string}}</p>
		</b-modal>

		<b-modal :title="$t('error_message')" v-model="showErrorModal" :ok-title="$t('ok')" :ok-only="true">
			<b-alert :show="showErrorModal" variant="danger"><i class="fa fa-exclamation-triangle"></i> {{errorMsg}}</b-alert>
		</b-modal>

		<b-modal
		:title="$t('members_setting.car_members')"
		v-model="showCarMemberRegisterModal"
		:hide-footer="true"
		:hide-header="false">
		<div>
			<b-input-group class="mb-2">
				<b-input-group-prepend>
					<b-input-group-text style="custom_input_prepend">{{$t('members_setting.card_number')}}</b-input-group-text>
				</b-input-group-prepend>
				<b-form-input type="text" 
					ref="car_member_cardno"
					v-model="car_member_cardno"
					class="text-center" 
					:placeholder="$t('members_setting.card_number_placeholder')"
					autocomplete="off"
					autofocus
					maxlength="20"
					style="font-size: 1.0rem;"/>
			</b-input-group>
		</div>
		<div class="mb-1">
			<table border="0" cellpadding="3">
				<tr style="font-size: 1.0rem; color: #2373E6;">
					<td style="vertical-align: top;"><span>※</span></td>
					<td>{{$t('members_setting.car_members_remark1')}}</td>
				</tr>
				<tr style="font-size: 1.0rem; color: #2373E6;">
					<td style="vertical-align: top;"><span>※</span></td>
					<td>{{$t('members_setting.car_members_remark2')}}<br>({{$t('members_setting.car_members_remark3')}})</td>
				</tr>
			</table>
		</div>
		<div class="row">
			<div v-if="car_member_cardno_invalid" style="font-size: 1.2rem" class="col-xs-12 col-md-12 text-center text-danger">{{$t('members_setting.bind_fail_message')}}</div>
			<div v-if="CarMemberRegisterProcessing" class="col-xs-12 col-md-12 text-center">
				<b-button variant="warning" class="top-up-btn-sm"><i class="fa fa-spinner"></i>{{$t('members_setting.checking')}}</b-button>
			</div>
			<div v-if="CarMemberRegisterResult" style="font-size: 1.2rem" class="col-xs-12 col-md-12 text-center" :class="CarMemberRegisterSuccess ? 'text-primary' : 'text-danger'">
				{{$t('members_setting.bind_error')}}: {{CarMemberRegisterResult}}
			</div>
			<div class="col-xs-12 col-md-12 text-center mt-3" v-if="!CarMemberRegisterProcessing">
			<b-button variant="primary" class="top-up-btn-sm" @click="CarMemberRegister()">{{$t('ok')}}</b-button>
			</div>
		</div>
		</b-modal>

		<b-modal
		:title="$t('members_setting.members')"
		v-model="showMemberRegisterModal"
		:hide-footer="true"
		:hide-header="false">
		<div>
			<b-input-group class="mb-2">
				<b-input-group-prepend>
					<b-input-group-text style="custom_input_prepend">{{$t('members_setting.card_number')}}</b-input-group-text>
				</b-input-group-prepend>
				<b-form-input type="text" 
					ref="member_cardno"
					v-model="member_cardno"
					class="text-center" 
					:placeholder="$t('members_setting.card_number_placeholder')"
					autocomplete="off"
					autofocus
					maxlength="20"
					style="font-size: 1.0rem;"/>
			</b-input-group>
		</div>
		<div class="mb-1">
			<table border="0" cellpadding="3">
				<tr style="font-size: 1.0rem; color: #2373E6;">
					<td style="vertical-align: top;"><span>※</span></td>
					<td>{{$t('members_setting.members_remark1')}}</td>
				</tr>
				<tr style="font-size: 1.0rem; color: #2373E6;">
					<td style="vertical-align: top;"><span>※</span></td>
					<td>{{$t('members_setting.members_remark2')}}<br>({{$t('members_setting.members_remark3')}})</td>
				</tr>
			</table>
		</div>
		<div class="row">
			<div v-if="member_cardno_invalid" style="font-size: 1.2rem" class="col-xs-12 col-md-12 text-center text-danger">{{$t('members_setting.bind_fail_message')}}</div>
			<div v-if="MemberRegisterProcessing" class="col-xs-12 col-md-12 text-center">
				<b-button variant="warning" class="top-up-btn-sm"><i class="fa fa-spinner"></i>{{$t('members_setting.checking')}}</b-button>
			</div>
			<div v-if="MemberRegisterResult" style="font-size: 1.2rem" class="col-xs-12 col-md-12 text-center" :class="MemberRegisterSuccess ? 'text-primary' : 'text-danger'">
				{{$t('members_setting.bind_error')}}: {{MemberRegisterResult}}
			</div>
			<div class="col-xs-12 col-md-12 text-center mt-3" v-if="!MemberRegisterProcessing">
			<b-button variant="primary" class="top-up-btn-sm" @click="MemberRegister()">{{$t('ok')}}</b-button>
			</div>
		</div>
		</b-modal>

		<b-modal
		:title="$t('members_setting.user_info')"
		v-model="showUserInfoModal"
		:hide-footer="true"
		:hide-header="false">

			<b-input-group class="mb-3">
				<b-input-group-prepend>
					<b-input-group-text style="custom_input_prepend">{{$t('members_setting.name')}}</b-input-group-text>
				</b-input-group-prepend>
				<b-form-input type="text" 
					class="form-control" 
					:placeholder="$t('members_setting.name_placeholder')" 
					v-model.lazy.trim="$v.edit_name.$model"
					:state="chkState('edit_name')"
					aria-describedby="invalidNameFeedback"/>
				<b-form-invalid-feedback id="invalidNameFeedback">{{$t('members_setting.invalidNameFeedback')}}</b-form-invalid-feedback>
			</b-input-group>

			<b-input-group class="mb-3">
				<b-input-group-prepend>
					<b-input-group-text style="custom_input_prepend">{{$t('members_setting.email')}}</b-input-group-text>
				</b-input-group-prepend>
				<b-form-input type="email" 
					class="form-control" 
					:placeholder="$t('members_setting.email_placeholder')" 
					v-model.lazy.trim="$v.edit_email.$model"
					v-focus
					:state="chkState('edit_email')"
					aria-describedby="invalidEmailFeedback"/>
				<b-form-invalid-feedback id="invalidEmailFeedback">{{$t('members_setting.invalidEmailFeedback')}}</b-form-invalid-feedback>
			</b-input-group>

			<b-input-group class="mb-3">
				<b-input-group-prepend>
					<b-input-group-text style="custom_input_prepend">{{$t('members_setting.phone')}}</b-input-group-text>
				</b-input-group-prepend>
				<b-form-input readonly type="tel" 
					class="form-control" 
					:placeholder="$t('members_setting.phone_placeholder')" 
					v-model.lazy.trim="$v.edit_phone.$model"
					:state="chkState('edit_phone')"
					aria-describedby="invalidPhoneFeedback"
					maxLength="10"/>
				<b-form-invalid-feedback id="invalidPhoneFeedback">{{$t('members_setting.invalidPhoneFeedback')}}</b-form-invalid-feedback>
			</b-input-group>

			<b-input-group class="mb-3">
				<b-input-group-prepend>
					<b-input-group-text style="custom_input_prepend"><i class="fa fa-grav"></i></b-input-group-text>
				</b-input-group-prepend>
				<b-form-input type="text" 
					class="form-control" 
					:placeholder="$t('members_setting.token_placeholder')" 
					v-model.lazy.trim="$v.token1.$model"
					:state="chkState('token1')"
					aria-describedby="invalidTokenFeedback"/>
				<b-input-group-append>
					<b-button variant="success" :disabled="false" class="px-4" @click="getToken()">{{$t('members_setting.getToken')}}</b-button>
				</b-input-group-append>
				<b-form-invalid-feedback id="invalidTokenFeedback">{{$t('members_setting.invalidTokenFeedback')}}</b-form-invalid-feedback>
				<span class="d-inline-block w-100 text-warning" v-if="is_get_token_clicked">{{$t('members_setting.getTokenRemarks')}}</span>
			</b-input-group>

			<b-row>
				<b-col cols="12">
					<b-button variant="primary" :disabled="!$v.token1.required||resetenduser_processing" class="top-up-btn-sm" @click="user_info_submit()">{{$t('members_setting.user_info_submit')}}</b-button>
					<span class="text-center d-inline-block w-100 text-warning" v-if="resetenduser_processing">{{$t('members_setting.resetenduser_processing')}}</span>
				</b-col>
			</b-row>
		</b-modal>

		<b-modal
		:title="$t('members_setting.change_password')"
		v-model="showUserPasswordModifyModal"
		:hide-footer="true"
		:hide-header="false">

			<b-input-group class="mb-3">
				<b-input-group-prepend>
					<b-input-group-text style="custom_input_prepend"><i class="fa fa-key"></i></b-input-group-text>
				</b-input-group-prepend>
				<b-form-input type="password" 
					class="form-control" 
					:placeholder="$t('members_setting.password_placeholder')" 
					v-model.lazy.trim="$v.password.$model"
					:state="chkState('password')"
					aria-describedby="invalidPasswordFeedback"/>
				<b-form-invalid-feedback id="invalidPasswordFeedback">{{$t('members_setting.invalidPasswordFeedback', { min: $v.password.$params.minLength.min})}}</b-form-invalid-feedback>
			</b-input-group>

			<b-input-group class="mb-3">
				<b-input-group-prepend>
					<b-input-group-text style="custom_input_prepend"><i class="fa fa-key"></i></b-input-group-text>
				</b-input-group-prepend>
				<b-form-input type="password" 
					class="form-control" 
					:placeholder="$t('members_setting.repeat_password_placeholder')" 
					v-model.lazy.trim="$v.repeatPassword.$model"
					:state="chkState('repeatPassword')"
					aria-describedby="invalidPassword2Feedback"/>
				<b-form-invalid-feedback id="invalidPassword2Feedback">{{$t('members_setting.invalidPassword2Feedback')}}</b-form-invalid-feedback>
			</b-input-group>

			<b-input-group class="mb-3">
				<b-input-group-prepend>
					<b-input-group-text style="custom_input_prepend"><i class="fa fa-grav"></i></b-input-group-text>
				</b-input-group-prepend>
				<b-form-input type="text" 
					class="form-control" 
					:placeholder="$t('members_setting.token_placeholder')" 
					v-model.lazy.trim="$v.token.$model"
					:state="chkState('token')"
					aria-describedby="invalidTokenFeedback"/>
				<b-input-group-append>
					<b-button variant="success" :disabled="false" class="px-4" @click="getToken()">{{$t('members_setting.getToken')}}</b-button>
				</b-input-group-append>
				<b-form-invalid-feedback id="invalidTokenFeedback">{{$t('members_setting.invalidTokenFeedback')}}</b-form-invalid-feedback>
				<span class="d-inline-block w-100 text-warning" v-if="is_get_token_clicked">{{$t('members_setting.getTokenRemarks')}}</span>
			</b-input-group>

			<b-row>
				<b-col cols="12">
					<b-button variant="primary" :disabled="!$v.token.required||resetpassword_processing" class="top-up-btn-sm" @click="password_submit()">{{$t('members_setting.password_submit')}}</b-button>
					<span class="text-center d-inline-block w-100 text-warning" v-if="resetpassword_processing">{{$t('members_setting.resetpassword_processing')}}</span>
				</b-col>
			</b-row>
		</b-modal>
	</div>
</template>
<script>
import { required, minLength, between, email, sameAs, maxLength } from 'vuelidate/lib/validators'
import Vue from 'vue'
import config from '@/config/global'
import notifications from '@/config/notifications'
import jQuery from 'jquery'
import moment from 'moment-timezone'

import { BrowserQRCodeReader } from '@zxing/library';

const codeReader = new BrowserQRCodeReader();

let eventbus = config.eventbus;
let scanner  = null;
const encrypt  = config.encrypt;
const decrypt  = config.decrypt;
const api_root = config.api_root;

const mail = (value) => {
  //const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const emailRegex = /^(?!.*\.\.)(?!\.)(?!.*\.$)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(value || '');
};

const cellphone = (value) => {
  const phoneRegex = /^09\d{8}$/;
  return phoneRegex.test(value || '') ;
};

let getUrlParameter = function getUrlParameter(url) {
  let sPageURL = url.substring(url.indexOf('?')+1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i,
      rlt={};

  for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      rlt[sParameterName[0]] = sParameterName[1];
  }

  return rlt;
};//eo getUrlParameter

const generateRandomToken = () => {
  // 使用 36 進位，並串接兩個隨機數來增加長度
  const part1 = Math.random().toString(36).slice(2).toUpperCase();
  const part2 = Math.random().toString(36).slice(2).toUpperCase();
  const part3 = Math.random().toString(36).slice(2).toUpperCase();
  return `${part1}${part2}${part3}`; 
};

let user_id_token_check = function(app){   
  let user = app.$state.$get('user');

  if(!user) {
    //console.info(`user_id_token_check no user`);
    return;
  }
  //console.info(`user_id_token_check user.uuid: ${user.uuid}`);

  let action = `${config.mqtt_root}/user_id_token_check`;
  fetch(action, {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + app.$state.$get('user').token
    },
    body: JSON.stringify({
    user_id: user.uuid
    })
  }).then(res => res.json()).then(result => {
    if(result.success === false){  
      //console.info(`user_id_token_check fail`); 
      app.showError({
        title: app.$t('user_check_error_title'),
        message: app.$t('user_check_error_message')
      });
      app.$state.$del('user');
      app.$router.push('/');
    }
  }).catch(error => {
    app.showError({
      title: app.$t('user_check_error_title'),
      message: app.$t('user_check_error_message')
    });
    app.$state.$del('user');
    app.$router.push('/');
  });
};

function get_end_user_info(app, uuid) {
  return new Promise((resolve, reject) => {
    //let user = app.$state.$get('user');

    if(!uuid) {//ignore check
      resolve();
    } else {
		let request_data = {
			encrypt_user_id: uuid,
		};
		request_data = encodeURIComponent(config.encrypt(JSON.stringify(request_data), config.ffkey, config.ffiv));
		let after = (google_captcha) => {
			let action = `${config.mqtt_root}/get_end_user_info`;
			fetch(action, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + app.$state.$get('user').token,
				},
				body: JSON.stringify({
					request: request_data,
					ggtoken: google_captcha
				})
			}).then(res => res.json()).then(result => {
				if(result.success){
					if(result.user) {
						let end_user = result.user;
						//console.info(`end_user.id: `, end_user.id);
						app.username = end_user.email ? end_user.email : '';
						app.isDemo = end_user.demo;
						app.name = end_user.name;
						app.phone = end_user.phone;
						if(app.username.indexOf('@') !== -1) { //email login user.
							app.email = end_user.email2 ? end_user.email2 : end_user.email;	
						} else { //phone login user
							app.email = end_user.email2 ? end_user.email2 : '';
						}

						app.edit_name = app.name;
						app.edit_phone = app.phone;
						app.edit_email = app.email;
					}
				}
				resolve();
			}).catch(error => {
				resolve();
			});
		}

		grecaptcha.execute(config.captcha_key, {action: 'enduserinfo'}).then(function(ggtoken) {
			// console.info('grecaptcha.token:', ggtoken);
			after(ggtoken);
		});
    }
  });
};

export default {
	name: 'MembersSetting',
	notifications,
	data(){
		let $tz = moment().tz(config.timezone);
    	let root = this;
		const user = this.$state.$get('user');
		return {
			theme: '',
			isDemo: 'YES',
			fontSize: 16,
			start_time:'',
			end_time:'',
			username: '',
			showUserInfoModal: false,
			name: '',
			phone: '',
			email: '',
			edit_name: '',
			edit_phone: '',
			edit_email: '',
			showUserPasswordModifyModal: false,
			password: '',
      		repeatPassword: '',
			token: '',
			token1: '',
			is_get_token_clicked: false,
			resetenduser_processing: false,
			resetpassword_processing: false,
			showErrorModal: false,
			showCameraModal: false,
			qrcode_string: '',
			errorMsg:'',
      		cameraDevices: [],
			car_member_cardno: '',
			car_member_cardno_invalid: false,
			showCarMemberRegisterModal: false,
			CarMemberRegisterProcessing: false,
			CarMemberRegisterResult: null,
			CarMemberRegisterSuccess: false,
			CarMemberRegisterErrorCount: 0,
			member_cardno: '',
			member_cardno_invalid: false,
			showMemberRegisterModal: false,
			MemberRegisterProcessing: false,
			MemberRegisterResult: null,
			MemberRegisterSuccess: false,
			MemberRegisterErrorCount: 0,
		}
	},//eo data
	created() {
		let app = this;
		
		app.$on('qrcodeDetected', function(result){
			//console.info('qr result:', result);
			
			app.$emit('reveived-qrcode', result);
			app.show_qrcode_canvas = false; 
			app.showCameraModal    = false;

			let params = getUrlParameter(result);
					
			if(params && params.uuid){
				app.uuid = decodeURIComponent(params.uuid);
				app.$state.$set('uuid', app.uuid);
				
				//Attention!! JQuery.param will add encodeURIComponent() for params automatically. So "DO NOT" add by yourself(Avoid double encode issue).
				let href = location.origin + '/#/dashboard/showdevice?' + jQuery.param({
				uuid: app.uuid
				});

				// console.info('href:', href);

				window.location = href;

				location.reload();
			}
		});
	},
	mounted() {
		let app   = this;
		let user  = this.$state.$get('user');
		let token = user ? this.$state.$get('user').token : null;

    	//console.info('MemberSetting user.uuid: ', user.uuid);
		if(!user) {
			app.showError({message:app.$t('please_login')});
            let _vcc = setTimeout(() => {
              app.$router.push('/');
              clearTimeout(_vcc);
            }, 1500);
			return;
		}

		//Added force logout to avoid user.user_id encrypt with wrong iv/key when backend server restarting.
		user_id_token_check(app);

		if(!token){
			this.$state.$set('error', config.error.INVALID_USER);
	    	this.$router.push('/');
	    	return;
		}

		eventbus.$on('start-qrcode-scanning', this.openQrCodeScanner);

		get_end_user_info(app, user.uuid);

		//this.setFontSize();
		//window.addEventListener('resize', this.setFontSize);
	},//eo mounted
	beforeDestory(){
		//window.removeEventListener('resize', this.setFontSize);
	},//eo beforeDestory

	methods: {
		openQrCodeScanner() {
			let app = this;

			app.showCameraModal       = true
			app.show_scan_qrcode_msg = true;
			app.show_qrcode_canvas   = true;

			// let _ccc = setTimeout(() => {
			//  clearTimeout(_ccc);
			//  init_qrcode_reader(app);
			// }, 1000);

			codeReader
			.listVideoInputDevices()
			.then((videoInputDevices) => {
				let targetCamera;
				videoInputDevices.forEach((device) => {
				this.cameraDevices.push(`${device.label}, ${device.deviceId}`);
				if (this.camera === 'front' && device.label.toLowerCase().indexOf('front') !== -1) {
					targetCamera = device.deviceId;
					return false;
				}
				return true;
				});
				codeReader
				.decodeFromInputVideoDevice(undefined, 'qrvideo')
				.then(result => this.onDecode(result.text))
				.catch(err => {
				// this.showError({message:this.$t('qr_code_detect_error')});
				console.error(err)
				});
			})
			.catch(err => { 
				this.showError({message:this.$t('qr_code_detect_error')});
				console.error(err)
			});

		},//eo openQrCodeScanner
		onDecode(data) {
			this.$emit('qrcodeDetected', data);
			this.showSuccess({message:this.$t('qr_code_detected')});
		},
		hideScanner(){
			// let app = this;
			// app.getVideo().stop();
			if(scanner !== null && scanner.destroy){
				scanner.destroy();
				scanner = null;
			}
		},//eo hideScanner
		setFontSize() {
			//const width = this.$refs.myButton.offsetWidth; // 获取按钮的宽度
			//this.fontSize = width / 10; // 假设字体大小是按钮宽度的十分之一
		},
		user_info_submit(){
			let app = this;
			let user = app.$state.$get('user');
			if(!user || app.username == '') {
				app.showError({message:app.$t('members_setting.error.user_name_error'), timeout: 15000});
				return false;
			}
			//console.info(`user: `, user);

			app.$v.edit_name.$touch();
			app.$v.edit_phone.$touch();
			app.$v.edit_email.$touch();
			app.$v.token1.$touch();

			if (app.$v.edit_name.$invalid || app.$v.edit_phone.$invalid || app.$v.edit_email.$invalid || app.$v.token1.$invalid) {
				app.showError({message:app.$t('members_setting.error.input_error'), timeout: 15000});
				return false;
			}

			grecaptcha.execute(config.captcha_key, {action: 'userinfoupdate'}).then(function(ggtoken) {
				let username = app.username;
				let name     = app.edit_name;
				let email2    = app.edit_email;
				let token1    = app.token1;
				
				app.resetenduser_processing = true;
				let action = `${api_root}/enduser/info_update`;
				let params   = {
					keyset: 'mqtt',
					form: encodeURIComponent(encrypt(JSON.stringify({
						username,
						name,
						email2,
						token: token1
					}))),
					frontend:location.origin,
					ggtoken
				};
				fetch(action, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + app.$state.$get('user').token,
					},
					body: JSON.stringify(params)
				}).then(res => res.json()).then(result => {
					if(!result.success){
						if(result.message === 'USER_NOT_EXIST') {
							app.showWarn({
								message: app.$t('members_setting.warning.user_not_exist', { username }),
								timeout: 15000
							});
						} else if(result.message === 'RECAPTCHA_FAIL'){
							app.showError({
								message: app.$t('members_setting.error.recaptcha_fail'),
								timeout: 15000
							});
						} else {
							app.showError({
								message: app.$t('members_setting.error.update_others_error'),
								timeout: 15000
							});
						}
					} else {
						app.showSuccess({
							message: app.$t('members_setting.save_success'),
							timeout: 5000
						});

						user.name = app.edit_name;
						user.username = app.edit_name;
						user.email2 = app.edit_email;
						jQuery('#username-placeholder').html(user.username);

						app.$state.$set('user', user);//update user
						//console.info(`update user: `, user);
						
						app.name = app.edit_name;
						app.email = app.edit_email;
						app.token1 = '';
						app.showUserInfoModal = false;
					}
					app.resetenduser_processing = false;
				}).catch(error => {
					app.showError({
						message: app.$t('members_setting.request_fail') + JSON.stringify(error), //TODO: i18n
						timeout: 15000
					});
					app.resetenduser_processing = false;
				});
			});
		},//eo user_info_submit
		password_submit(){
			let app = this;
			let user = app.$state.$get('user');

			if(!user) {
				app.showError({message:app.$t('members_setting.error.user_name_error'), timeout: 15000});
				return false;
			}

			app.$v.password.$touch();
			app.$v.repeatPassword.$touch();
			app.$v.token.$touch();

			if (app.$v.password.$invalid || app.$v.repeatPassword.$invalid || app.$v.token.$invalid) {
				app.showError({message:app.$t('members_setting.error.input_error'), timeout: 15000});
				return false;
			}

			grecaptcha.execute(config.captcha_key, {action: 'resetpasswordform'}).then(function(ggtoken) {
				let username = app.username;
				let password = app.password;
				let token    = app.token;

				app.resetpassword_processing = true;
				let action = `${api_root}/enduser/resetpassword`;
				let params   = {
					keyset: 'mqtt',
					form: encodeURIComponent(encrypt(JSON.stringify({
						username,
						password,
						token
					}))),
					frontend:location.origin,
					ggtoken
				};
				fetch(action, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + app.$state.$get('user').token,
					},
					body: JSON.stringify(params)
				}).then(res => res.json()).then(result => {
					if(!result.success){
						if(result.message === 'USER_NOT_EXIST') {
							app.showWarn({
								message: app.$t('members_setting.warning.user_not_exist', { username }),
								timeout: 15000
							});
						} else if(result.message === 'RECAPTCHA_FAIL'){
							app.showError({
								message: app.$t('members_setting.error.recaptcha_fail'),
								timeout: 15000
							});
						} else if(result.message === 'INVALID_TOKEN'){
							app.showError({
								message: app.$t('members_setting.error.invalid_token'),
								timeout: 15000
							});
						} else {
							app.showError({
								message: app.$t('members_setting.error.reset_others_error'),
								timeout: 15000
							});
						}
					} else {
						app.showSuccess({
							message: app.$t('members_setting.reset_password_success'),
							timeout: 5000
						});
						app.showUserPasswordModifyModal = false;
						app.password = '';
						app.repeatPassword = '';
						app.token = '';
					}
					app.resetpassword_processing = false;
				}).catch(error => {
					app.showError({
						message: app.$t('members_setting.request_fail') + JSON.stringify(error), //TODO: i18n
						timeout: 15000
					});
					app.resetpassword_processing = false;
				});
			});
		},//eo reset_password_submit
		getToken(){
			let app = this;

			if(app.username == '') {
				app.showError({message:app.$t('members_setting.error.user_name_error'), timeout: 15000});
				return false;
			}

			if(app.is_get_token_clicked){
				app.showWarn({
					message: app.$t('members_setting.warning.wait_token_get')
				});
				return false;
			}

			app.is_get_token_clicked = true;

			let _cc = setTimeout(() => {
				app.is_get_token_clicked = false;
			}, 30000);

			grecaptcha.execute(config.captcha_key, {action: 'resetpassword'}).then(function(ggtoken) {
				let username = app.username;
				let action   = `${api_root}/enduser/resetpassword_send_token`;
				let params   = {
					keyset: 'mqtt',
					username: encodeURIComponent(encrypt(JSON.stringify({username}))),
					ggtoken,
				};

				fetch(action, {
					method: 'POST',
					headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + generateRandomToken()
					},
					body: JSON.stringify(params)
				}).then(res => res.json()).then(result => {
					if(!result.success){
						if(result.message === 'USER_NOT_EXIST') {
							app.showWarn({
								message: app.$t('members_setting.warning.user_not_exist', { username }),
								timeout: 15000
							});
						} else if(result.message === 'RECAPTCHA_FAIL'){
							app.showError({
								message: app.$t('members_setting.error.recaptcha_fail'),
								timeout: 15000
							});
						} else {
							app.showError({
								message: app.$t('members_setting.error.token_others_error'),
								timeout: 15000
							});
						}
						clearTimeout(_cc);
						app.is_get_token_clicked = false;
					} else {
						let message = app.$t('members_setting.token_sent', { username });
						if(username.indexOf('@') !== -1) { //email login user.
							message += app.$t('members_setting.check_email');
						} else { //phone login user
							message += app.$t('members_setting.check_phone');
						}
						app.showSuccess({
							message,
							timeout: 15000
						});
					}
				}).catch(error => {
				});
			});
		},//eo getToken
		chkState(val) {
			const field = this.$v[val];
			return !field.$dirty || !field.$invalid;
		},//eo chkState
		popCarMemberRegisterModal() {
			if(this.$state.$get('isDemo') === 'YES'){
				this.showError({message: this.$t('demo_account_error')});
				return;
			}
			this.showCarMemberRegisterModal = true;
			this.CarMemberRegisterResult = null;
			this.car_member_cardno_invalid = false;
			this.car_member_cardno = '';

			let __vcc = setTimeout(() =>{
				this.$refs.car_member_cardno.focus();
				clearTimeout(__vcc);
			} , 800);
		}, // eo popCarMemberRegisterModal
		CarMemberRegister() {
			let app = this;
			this.car_member_cardno_invalid = false;
			this.CarMemberRegisterResult = null;

			//去除空白/全型空白/Tab/換行/CR
			this.car_member_cardno = this.car_member_cardno.replace(/[\s\u3000]/g, '');

			if (this.car_member_cardno.length <= 0) {
				this.car_member_cardno_invalid = true;
			} else {
				if(this.CarMemberRegisterErrorCount < 3) {
					this.CarMemberRegisterProcessing = true;
					let action = `${config.mqtt_root}/car_member_register`;
					fetch(action, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + this.$state.$get('user').token,
						},
						body: JSON.stringify({
							user_id: encodeURIComponent(this.$state.$get('user').uuid),
							keyset: 'mqtt',
							cardno: encodeURIComponent(config.encrypt(this.car_member_cardno.toUpperCase(), config.ffkey, config.ffiv)),
						})
					}).then(res => res.json()).then(result => {
						//console.info('car member register result', result);
						this.CarMemberRegisterSuccess = result.success;
						this.CarMemberRegisterResult = result.message + (result.rlt && result.rlt.Message ? ':' + result.rlt.Message : ''); //TODO: i18n

						if (result.success) {
							this.CarMemberRegisterErrorCount = 0;
							this.showCarMemberRegisterModal = false;
							this.showSuccess({
							message: result.message, //TODO: i18n
							});
						} else {
							this.CarMemberRegisterErrorCount++;
							if(this.CarMemberRegisterErrorCount == 3) {
								let __car_member_error_reset = setTimeout(() =>{
									this.CarMemberRegisterErrorCount = 0;
									clearTimeout(__car_member_error_reset);
								} , 30000);
							}
						}
						this.CarMemberRegisterProcessing = false;
					}).catch(error => {
						// console.info('car member register error', error);
						// this.showError(error);
						this.CarMemberRegisterProcessing = false;
					});
				} else {
					app.showError({message:app.$t('members_setting.error.bind_retry_error')});
				}
			}
		}, // eo CarMemberRegister

		popMemberRegisterModal() {
			if(this.$state.$get('isDemo') === 'YES'){
				this.showError({message: this.$t('demo_account_error')});
				return;
			}
			this.showMemberRegisterModal = true;
			this.MemberRegisterResult = null;
			this.member_cardno_invalid = false;
			this.member_cardno = '';

			let __vcc1 = setTimeout(() =>{
				this.$refs.member_cardno.focus();
				clearTimeout(__vcc1);
			} , 800);
		}, // eo popMemberRegisterModal
		MemberRegister() {
			let app = this;
			this.member_cardno_invalid = false;
			this.MemberRegisterResult = null;
			//console.info('this.member_cardno.length', this.member_cardno.length);
			
			//去除空白/全型空白/Tab/換行/CR
			this.member_cardno = this.member_cardno.replace(/[\s\u3000]/g, '');

			if (this.member_cardno.length <= 0) {
				this.member_cardno_invalid = true;
			} else {
				if(this.MemberRegisterErrorCount < 3) {
					this.MemberRegisterProcessing = true;
					let action = `${config.mqtt_root}/member_register`;
					fetch(action, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + this.$state.$get('user').token,
						},
						body: JSON.stringify({
							user_id: encodeURIComponent(this.$state.$get('user').uuid),
							keyset: 'mqtt',
							cardno: encodeURIComponent(config.encrypt(this.member_cardno.toUpperCase(), config.ffkey, config.ffiv)),
						})
					}).then(res => res.json()).then(result => {
						//console.info('member register result', result);
						this.MemberRegisterSuccess = result.success;
						this.MemberRegisterResult = result.message + (result.rlt && result.rlt.Message ? ':' + result.rlt.Message : ''); //TODO: i18n

						if (result.success) {
							this.MemberRegisterErrorCount = 0;
							this.showMemberRegisterModal = false;
							this.showSuccess({
							message: result.message, //TODO: i18n
							});
						} else {
							this.MemberRegisterErrorCount++;
							if(this.MemberRegisterErrorCount == 3) {
								let __member_error_reset = setTimeout(() =>{
									this.MemberRegisterErrorCount = 0;
									clearTimeout(__member_error_reset);
								} , 30000);
							}
						}
						this.MemberRegisterProcessing = false;
					}).catch(error => {
						// console.info('member register error', error);
						// this.showError(error);
						this.MemberRegisterProcessing = false;
					});
				} else {
					app.showError({message:app.$t('members_setting.error.bind_retry_error')});
				}
			}
		}, // eo MemberRegister
		popUserInfoModal() {
			let app = this;
			if(this.$state.$get('isDemo') === 'YES'){
				this.showError({message: this.$t('demo_account_error')});
				return;
			}
			app.edit_name = app.name;
			app.edit_phone = app.phone;
			app.edit_email = app.email;
			app.token1 = '';
			this.showUserInfoModal = true;
		}, // eo popUserInfoModal
		popUserPasswordModifyModal() {
			let app = this;
			if(this.$state.$get('isDemo') === 'YES'){
				this.showError({message: this.$t('demo_account_error')});
				return;
			}
			app.password = '';
			app.repeatPassword = '';
			app.token = '';
			this.showUserPasswordModifyModal = true;
		}, // eo popUserPasswordModifyModal
	},//eo methods

	validations: {
		edit_name: {
			required,
			minLength: minLength(2)
		},
		edit_phone: {
			cellphone,
			required,
			minLength: minLength(10),
			maxLength: maxLength(10)
		},
		edit_email: {
			mail,
			required,
			minLength: minLength(4)
		},
		password: {
			required,
			minLength: minLength(5),
		},
		repeatPassword: {
			required,
			minLength: minLength(5),
			sameAs: sameAs('password')
		},
		token: {
			required,
			minLength: minLength(6)
		},
		token1: {
			required,
			minLength: minLength(6)
		},
	}//eo validations
}
</script>

<style>
.breadcrumb{display: none;}
.pt-3, .py-3 { padding-top: 0.35rem !important; }
.VueTables__search-field label, .VueTables__limit-field label{
	display: none;
	width: 0px;
}
.top-up-btn{
height: 4rem;
max-width: 98%;
min-width: 98%;
font-size: min(5.0vw, 1.5rem) !important;
margin: 0.5px 0px;
}
.top-up-btn-sm{
height: 3rem;
max-width: 100%;
min-width: 100%;
font-size: 1.5rem;
}
.custom_input_prepend{
	width: 100px !important;
	text-align: left;
	font-size: 1.5rem;
}
.grecaptcha-badge{
	display: none;
}
.button_auto_font_size {
	font-size: 1.5vw;
}
</style>

<style src="spinkit/scss/spinkit.scss" lang="scss" />